import { render, staticRenderFns } from "./sidebarLayout.vue?vue&type=template&id=0efd759c&scoped=true"
import script from "./sidebarLayout.vue?vue&type=script&lang=js"
export * from "./sidebarLayout.vue?vue&type=script&lang=js"
import style0 from "./sidebarLayout.vue?vue&type=style&index=0&id=0efd759c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efd759c",
  null
  
)

export default component.exports